module.exports = __webpack_public_path__ + "epson.jpg?d6961e1be74466a42bfdbba8bb0cf612";